import m from "../../geodata/es2015/curacaoLow";
window.am4geodata_curacaoLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/curacaoLow.js
// module id = null
// module chunks = 